import jwt_decode from "jwt-decode";
import React, { useState, useContext, createContext } from "react";
import { getToken } from "../services/Auth";
import { salvaLogCredor } from "../services/requests/getUserInfo";

const AuthContext = createContext({});

function AuthInfo({ children }) {
  const token = getToken();
  const decoded = jwt_decode(token);
  const [user] = useState(decoded.usuario_nome);
  const [user_id] = useState(decoded.usuario_id);
  const multiploProvider = decoded.providers.length > 1 ? true : false;
  const providers = decoded.providers;
  const [provider, setProvider] = useState(
    multiploProvider
      ? "-"
      : decoded.providers[0].nome_fantasia
        ? decoded.providers[0].nome_fantasia
        : decoded.providers[0].nome
  );
  const [provider_id, setProvider_id] = useState(multiploProvider ? null : decoded.providers[0].usuario_id);

  const logCredor = async (usuario_id) => {
    const dadosLog = {
      id_usuario: decoded.usuario_id,
      action: "Login pague, escolha de provider",
      credor_id: usuario_id,
    };
    try {
      await salvaLogCredor(dadosLog);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        user_id,
        multiploProvider,
        providers,
        provider,
        provider_id,
        setProvider,
        setProvider_id,
        logCredor,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

function useAuth() {
  const context = useContext(AuthContext);
  return context;
}

export { useAuth, AuthInfo };
